export default "__VITE_ASSET__CzTtuFO7__"